import Hint from './Hint'

class HorizontalScrollHint extends Hint {
  constructor() {
    super({
      component: 'HorizontalScrollHint',
      transition: 'hint-fade',
      maxShowCount: 1,
    })
  }
}
export default HorizontalScrollHint
